export class DeletedEntitiesDto {
    deleted: DeletedEntityDto[] = [];
}

export class DeletedEntityDto {
    id = -1;
    version = -1;
}